import { render, staticRenderFns } from "./SectionFinal.vue?vue&type=template&id=3b52b1b7&"
import script from "./SectionFinal.vue?vue&type=script&lang=js&"
export * from "./SectionFinal.vue?vue&type=script&lang=js&"
import style0 from "./SectionFinal.vue?vue&type=style&index=0&id=3b52b1b7&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports